import { takeEvery } from 'redux-saga/effects';
import {
  MY_VIDEO_REQUEST,
  MY_VIDEOS_MOBILE_REQUEST,
  MY_VIDEOS_REQUEST,
  myVideoRequestEffect,
  myVideosRequestEffect,
  myVideosRequestMobileEffect,
  POST_DELETE,
  postDeleteEffect,
} from 'pages/my-videos.page';

export const myVideosPageSaga = function* () {
  yield takeEvery(MY_VIDEOS_REQUEST, myVideosRequestEffect);
  yield takeEvery(MY_VIDEOS_MOBILE_REQUEST, myVideosRequestMobileEffect);
  yield takeEvery(MY_VIDEO_REQUEST, myVideoRequestEffect);
  yield takeEvery(POST_DELETE, postDeleteEffect);
};
